import React, {useState} from 'react';
import '../css/DenotedGardenMenuBottomSectionStyling.css';

const DenotedGardenMenuBottomSection = ({ gardenInformation, savedGardenPlots, onNext, onRestart }) => {
    const totalSavedGardens = Object.keys(savedGardenPlots).length;
    const totalGardens = Object.keys(gardenInformation).length;
    const [showModal, setShowModal] = useState(false);
    const [unsavedGardens, setUnsavedGardens] = useState(gardenInformation);

    const handleNextClick = () => {
        if (totalSavedGardens === totalGardens && totalGardens > 0) {
            onNext();
        } else if (totalSavedGardens !== totalGardens && totalGardens > 0) {
            setShowModal(true);
        }
    }

    const handleCloseModal = () => {
        setShowModal(false);
    }

    return (
        <div className="garden-menu-bottom">
            <div className="garden-stats">
                🌱 You’ve saved <span className="highlight">{totalSavedGardens} / {totalGardens}</span> garden{totalGardens !== 1 ? 's' : ''}
            </div>
            <div className="garden-actions">
                <button onClick={handleNextClick}>Next</button>
                <button onClick={onRestart} className="restart-button">Restart</button>
            </div>

            {showModal && (
                <div className="unsaved-modal-overlay">
                    <div className="unsaved-modal-content">
                        <h2>⚠️ Unsaved Gardens Detected!</h2>
                        <p className="unsaved-modal-warning">
                            You have garden plots that haven't been saved. Please fill in all required info and save them before continuing.
                        </p>

                        <div className="unsaved-modal-plot-list">
                            <h4>Unsaved Gardens:</h4>
                            <ul>
                                {Object.keys(gardenInformation)
                                    .filter((name) => !savedGardenPlots.hasOwnProperty(name))
                                    .map((name) => (
                                        <li key={name}>🌿 {name}</li>
                                    ))}
                            </ul>
                        </div>

                        <div className="modal-buttons">
                            <button className="denoting-menu-bottom-close-button" onClick={handleCloseModal}>
                                Got it!
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default DenotedGardenMenuBottomSection;